import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="image-link"
export default class extends Controller {

  static targets = ["newTab", "url"];
  static values = { newRecord: Boolean };

  connect() {
    const { value } = this.urlTarget;
    this.#perform(value);
    this.#initializeNewTab();
  }

  onChange(event) {
    const { value } = event.target;
    this.#perform(value);
  }

  #perform(value) {
    const checkboxTarget = this.newTabTarget;
    const action = value ? "remove" : "add";
    checkboxTarget.classList[action]("hidden");
  }

  #initializeNewTab() {
    if (this.newRecordValue) {
      this.newTabTarget.querySelector('input').checked = false;
    }
  }
}
